import { observer } from 'mobx-react-lite'
import React from 'react'
import AgeGroupFilter from './Filters/AgeGroupFilter'
import AudienceAgeGroupFilter from './Filters/AudienceAgeGroupFilter'
import AudienceCityFilter from './Filters/AudienceCityFilter'
import AudienceCountryFilter from './Filters/AudienceCountryFilter'
import AudienceGenderFilter from './Filters/AudienceGenderFilter'
import CityFilter from './Filters/CityFilter'
import CountryFilter from './Filters/CountryFilter'
import EngagementRateFilter from './Filters/EngagementRateFilter'
import GenderFilter from './Filters/GenderFilter'
import ReachFilter from './Filters/ReachFilter'
import FilterField from './Filters/FilterField'

function Section({ title, description, children, className = '' }) {
  return (
    <section className={`rounded-xl border-1 border-rb-dash-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode p-5 ${className}`}>
      <div className="mb-4">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-rb-mat-grey dark:text-gray-400">{title}</h3>
        {description && <p className="mt-0.5 text-xs text-rb-lighter-grey dark:text-gray-500">{description}</p>}
      </div>
      {children}
    </section>
  )
}

export default observer(function SelectedFilters() {
  return (
    <div className="border-t-1 border-border-primary dark:border-rb-dark-mode-lighter bg-rb-grey dark:bg-rb-dark-mode-background">
      <div className="mx-auto grid max-w-[1400px] grid-cols-12 gap-4 px-8 py-5">
        <Section title="Performance" className="col-span-12">
          <div className="grid grid-cols-12 gap-8">
            <FilterField label="Follower range" className="col-span-8">
              <ReachFilter />
            </FilterField>
            <FilterField label="Minimum engagement rate" className="col-span-4">
              <EngagementRateFilter />
            </FilterField>
          </div>
        </Section>

        <Section title="Creator" description="Who the creator is" className="relative z-20 col-span-12 xl:col-span-6">
          <div className="grid grid-cols-2 gap-4">
            <FilterField label="Gender"><GenderFilter /></FilterField>
            <FilterField label="Age"><AgeGroupFilter /></FilterField>
            <FilterField label="Country"><CountryFilter /></FilterField>
            <FilterField label="City"><CityFilter /></FilterField>
          </div>
        </Section>

        <Section title="Audience" description="Who follows the creator" className="relative z-10 col-span-12 xl:col-span-6">
          <div className="grid grid-cols-2 gap-4">
            <FilterField label="Gender"><AudienceGenderFilter /></FilterField>
            <FilterField label="Age"><AudienceAgeGroupFilter /></FilterField>
            <FilterField label="Country" hint="min. share"><AudienceCountryFilter /></FilterField>
            <FilterField label="City"><AudienceCityFilter /></FilterField>
          </div>
        </Section>
      </div>
    </div>
  )
})
